import nativeStyled from '@emotion/native';
import { Text as BaseText, DigitalSignatureTheme } from '@diwala/killer-shrew';

export const Text = nativeStyled(BaseText)`
  color: ${DigitalSignatureTheme.introduction.text};
  display: block;
  padding-bottom: 8px;
  text-align: center;
`;
